import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { reconClient } from '../../../utils/axios';

// GET /api/v1/uploads/{id}/errors — row-level rejections for a session.
export const fetchUploadErrors = async ({ queryKey }) => {
  const [, sessionId, params] = queryKey;
  const { data } = await reconClient.get(`/uploads/${sessionId}/errors`, { params, skipErrorSnackbar: true });
  return data;
};

export const useGetUploadErrorsHandler = ({ sessionId, page = 0, pageSize = 100, enabled = true } = {}) => {
  const dispatch = useDispatch();

  const params = { limit: pageSize, offset: page * pageSize };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['recon-upload-errors', sessionId, params],
    queryFn: fetchUploadErrors,
    enabled: enabled && Boolean(sessionId),
    refetchOnWindowFocus: false,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      const message = error?.response?.data?.detail ?? error?.message ?? 'Failed to load row errors';
      dispatch(showSnackbar({ message, severity: 'error' }));
    }
  }, [dispatch, error, isError]);

  return { errors: data?.items ?? [], totalErrors: data?.total ?? 0, isLoading };
};
